// ----------------------------------------------------------------------
// <copyright file="Izenda.InvalidRelationship.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Invalid Relationship component
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';

import IconMenu from 'share/components/controls/Izenda.IconMenu';
import Button from 'share/components/controls/Izenda.Button';
import ActionBar from 'share/components/controls/Izenda.ActionBar';
import DataGridSearch from 'share/components/controls/DataGrid/Izenda.DataGridSearch';
import RelationshipList from './Izenda.RelationshipList';
import Alert from 'share/components/controls/Izenda.Alert';
import CommonMessages from 'share/messages/Izenda.CommonMessages';
import ExistingRelationshipPopup from './Izenda.ExistingRelationshipPopup';
import RelationshipStore from 'logic/Izenda.RelationshipStore';
import actions from './Izenda.RelationshipActions';
import { FIELDCHECK } from 'logic/data/Izenda.RelationshipConstants';

@connect(actions)
class InvalidRelationship extends Component {
  componentDidMount() {
    const props = this.props;
    const { store, loader, validation, isPopup } = props;

    props.updateLoading(true);
    loader.startLoading();
    store.initData(isPopup).then(function() {
      props.updateLoading(false);
      loader.endLoading();

      const allErrors = store.getInvalidErrors(FIELDCHECK);
      validation.updateErrors(allErrors);
    });
  }

  resetAlertMessage = () => {
    const { store } = this.props;
    store.alertMessage = CommonMessages.EMPTY_MESSAGE;
  }

  viewExistingRelationship = () => {
    const props = this.props;
    const store = new RelationshipStore();
    store.setEditable(false);
    store.initData(true).then(() => {
      props.openPopup(ExistingRelationshipPopup, { store, updateLoading: props.updateLoading });
    });
  }

  /**
   * render main function
   */
  render() {
    const { store, store: { alertMessage }, localization } = this.props;

    return (
      <div className='izenda-Wrapper'>
        <div className='izenda-Wrapper-header'>
          <IconMenu />
          <div className='izenda-Alert-container'>
            <Alert type={alertMessage.type} onAutoHide={this.resetAlertMessage}>
              {alertMessage.message}
            </Alert>
          </div>
          <div className='u_inlineBlock'>
            <DataGridSearch
              onSearch={this.props.onSearch}
              value={store.pageInfo.searchProperty}
              options={store.getCriteriaList()}
            />
          </div>
          {/* button groups*/}
          <ActionBar onSave={this.props.onSave} onCancel={this.props.onCancel}>
            <Button onClick={this.viewExistingRelationship} label={localization.getText('RELATIONSHIP_LABEL_VIEW_EXISTING')} />
            <Button onClick={this.props.onAdd} label={localization.getText('REPORTDESIGNER_LABEL_ADD_RELATIONSHIP')} />
          </ActionBar>
        </div>
        <div className='izenda-Wrapper-content'>
          <div>
            <Alert type='error' autoHide={false} className='u_marginLeft u_marginRight u_marginBottom'>
              {localization.getText('RELATIONSHIP_MESSAGES_INVALID_MESSAGE')}
            </Alert>
          </div>
          {/* list of relationship*/}
          <RelationshipList
            store={store}
            width={this.props.width}
            isPopup={this.props.isPopup}
            isLoading={this.props.isLoading}
            isHidePaging
            isSort
          />
        </div>
      </div>
    );
  }
}

InvalidRelationship.defaultProps = {
  isPopup: false
};

InvalidRelationship.propTypes = {
  store: PropTypes.object.isRequired,
  querySourceId: PropTypes.string,
  isPopup: PropTypes.bool
};

export default InvalidRelationship;


// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/Relationship/Izenda.InvalidRelationship.js